import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Noty from 'noty'

class CookieDialog extends Component {
    componentDidMount() {
        // for cookie policy
        const cookiePolicyNotyElement =
            this.refs.cookiePolicyHeader.innerHTML +
            this.refs.cookiePolicyBody.innerHTML
        if (!/isAgreeCookiePolicy=true/.test(document.cookie)) {
            const n = new Noty({
                type: 'alert',
                layout: 'bottomLeft',
                theme: 'mint',
                closeWith: [''],
                animation: {
                    open: 'animated bounceInLeft', // Animate.css class names
                    close: 'animated bounceOutLeft', // Animate.css class names
                },
                text: cookiePolicyNotyElement,
                buttons: [
                    Noty.button(
                        this.refs.sure.innerHTML,
                        'cookie-policy__btn',
                        function () {
                            document.cookie =
                                'isAgreeCookiePolicy=true;Expires=Tue, 01 Jan 2030 08:00:00 GMT+0800;path=/;'
                            n.close()
                        }
                    ),
                ],
            })
            n.show()
        }
    }

    componentDidUpdate(prevProps, prevState) {}

    render() {
        return (
            <div style={{ display: 'none' }}>
                <div ref="cookiePolicyHeader" id="cookiePolicyHeader">
                    <h2 className="cookie-policy__header">
                        <FormattedMessage id="cookiePolicyHeader" />
                    </h2>
                </div>
                <div ref="cookiePolicyBody">
                    <div className="cookie-policy__body">
                        <FormattedMessage id="cookiePolicyBody" />
                    </div>
                </div>
                <div ref="sure">
                    <FormattedMessage id="sure" />
                </div>
            </div>
        )
    }
}

export default CookieDialog
